export default "__VITE_ASSET__FGRvXaG4__"